import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { useMutationState } from '@tanstack/react-query';
import { SyntheticEvent } from 'react';
import { useAppointmentStore } from '@src/store';
const FormCTA = ({
  primaryButtonText = 'Continue',
  onClick,
  hideContinue = false,
  form,
  isAppointmentReview
}: {
  primaryButtonText?: string;
  onClick?: (e: SyntheticEvent) => void;
  hideContinue?: boolean;
  form?: string;
  isAppointmentReview?: boolean;
}) => {
  const {
    invalidAppointment
  } = useAppointmentStore(store => store);
  const isScheduleAppointmentPending = useMutationState({
    filters: {
      status: 'pending',
      mutationKey: ['scheduleAppointment']
    },
    select: mutation => mutation.state.variables
  });
  return hideContinue ? null : <Box display="flex" justifyContent="center" bgcolor="backgrounds.white" width={'100%'} py={2} position="sticky" bottom={0} sx={{
    boxShadow: '0 -1px 4px rgb(0 0 0 / 20%)'
  }} zIndex={2} data-sentry-element="Box" data-sentry-component="FormCTA" data-sentry-source-file="FormCTA.tsx">
			<Button type="submit" variant="primaryDefault" size="M" onClick={onClick} form={form} disabled={isAppointmentReview && (isScheduleAppointmentPending.length > 0 || invalidAppointment)} sx={{
      '&:hover:not(:focus)': {
        bgcolor: 'secondary.main'
      }
    }} data-sentry-element="Button" data-sentry-source-file="FormCTA.tsx">
				{primaryButtonText}
			</Button>
		</Box>;
};
export default FormCTA;